(ns frontend.actions.deal
  (:require [frontend.conn :as conn]
            [promesa.core :as p]
            [frontend.analytics :as analytics]
            [frontend.logging :as logging]))

;; NOTE
;; Should be one-to-one mapping with domain/oppo
;; No other tasks should be performed here
;; Should only be required in `events` files
;; Function signatures should always be
;; [data on-success! on-error!]
;; Keep it Simple and Silly

(defn *->put-on-hold [data on-success! on-error!]
  (-> (conn/sendp! :oppo/put-on-hold
                   data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->pass [data on-success! on-error!]
  (-> (conn/sendp! :oppo/pass
                   data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->add-to-portfolio [data on-success! on-error!]
  (-> (conn/sendp! :oppo/add-to-portfolio
                   data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->resurrect [data on-success! on-error!]
  (-> (conn/sendp! :oppo/resurrect
                   data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->delete-flag [data on-success! on-error!]
  (-> (conn/sendp! :oppo/delete-flag
                   data)
      (p/then on-success!)
      (p/catch on-error!))
  (analytics/event "Deal-flagged"))

(defn *->add-flag [data on-success! on-error!]
  (-> (conn/sendp! :oppo/add-flag
                   data)
      (p/then on-success!)
      (p/catch on-error!))
  (analytics/event "Deal-flagged"))

(defn toggle-flag [entity flagged?]
  (let [data {:oppo-id (:db/id entity)}
        on-success! (partial logging/unimplemented "toggle-flag!")
        on-error! (partial logging/error "toggle-flag!")]
    (if flagged?
      (*->delete-flag data on-success! on-error!)
      (*->add-flag data on-success! on-error!))))

(defn *->create-memo [data on-success! on-error!]
  (-> (conn/sendp! :oppo/create-memo
                   data 60000)                              ;; on slow connections 5 secs might not be enough
      (p/then on-success!)
      (p/catch on-error!))
  (analytics/event "Memo-created"))

(defn *->create-full-memo [data on-success! on-error!]
  (-> (conn/sendp! :oppo/create-full-memo
                   data 60000)                              ;; on slow connections 5 secs might not be enough
      (p/then on-success!)
      (p/catch on-error!))
  (analytics/event "Memo-created"))
